import { Button } from '@ksyos/design-system';
import React from 'react';
import { translateKey } from '../../../../../translate';
import { ProcessStartWizardButtonRow } from '../../../../elements/ProcessStartWizard/ProcessStartWizardButtonRow';

interface INewProcessActionButtonRowProps {
    onClick: (actionWithProcedure: boolean) => Promise<void>;
    selectedActionWithProcedure: boolean | undefined;
}

export function NewProcessActionButtonRow(props: INewProcessActionButtonRowProps): React.ReactElement {
    return (
        <ProcessStartWizardButtonRow label={translateKey('home.chooseStartResearch_action')}>
            {[
                <Button
                    className="automation-processFlowType-performSelf"
                    color="secondary"
                    key="performSelf"
                    onClick={async () => {
                        await props.onClick(true);
                    }}
                    variant={props.selectedActionWithProcedure !== true ? 'outline' : 'solid'}
                >
                    {translateKey('home.action_performSelf')}
                </Button>,

                <Button
                    className="automation-processFlowType-inquiry"
                    color="secondary"
                    key="inquiry"
                    onClick={async () => {
                        await props.onClick(false);
                    }}
                    variant={props.selectedActionWithProcedure !== false ? 'outline' : 'solid'}
                >
                    {translateKey('home.action_inquiry')}
                </Button>,
            ]}
        </ProcessStartWizardButtonRow>
    );
}
